// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import { ApiResponse, RoleRecord } from './types/types';
import { handleResponse } from '../../utils/api';
import { CreateRoleRequest } from './types/Role/roleRecord';

// Define a service using a base URL and expected endpoints
export const rolesAPI = createApi({
  reducerPath: 'rolesAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getRoles: builder.query<RoleRecord[], void>({
      query: () => ({
        url: `/auth/roles`,
        method: 'GET',
      }),
      transformResponse: (response: ApiResponse<RoleRecord[]>) => response.body,
    }),
    getRoleDetailsById: builder.query<RoleRecord, string>({
      query: (id: string) => {
        return {
          url: `/auth/role/${id}`,
          method: 'GET',
        };
      },
      transformResponse: (response: ApiResponse<RoleRecord>) => handleResponse(response).body,
    }),
    // Mutations
    createRole: builder.mutation({
      query: (request: CreateRoleRequest) => ({
        url: '/auth/role/create',
        method: 'POST',
        data: request,
      }),
      transformResponse: (response: ApiResponse<RoleRecord>) => handleResponse(response).body,
    }),
    updateRole: builder.mutation({
      query: (request: CreateRoleRequest) => ({
        url: '/auth/role/update',
        method: 'POST',
        data: request,
      }),
      transformResponse: (response: ApiResponse<RoleRecord>) => handleResponse(response).body,
    }),
    deleteRole: builder.mutation({
      query: (id: number) => ({
        url: `/auth/role/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRolesQuery,
  useGetRoleDetailsByIdQuery,
  useLazyGetRoleDetailsByIdQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = rolesAPI;
